import React from 'react';

/**
 * A component that displays a box with a count badge.
 * 
 * @param url The link clicking on the component will open in a new window
 * @param tooltip The text to display when the component is hovered over
 * @param icon And icon to show before the component's children
 * @param badge The component to show after the component's children
 * @param children The body of the component
 */
const NotificationBox = ({ url, tooltip, icon, badge, children }) => {
	// Determine whether to build a link or div element based on the presence of the {url} value
	const ElementTag = url ? 'a' : 'div';
	let conditionalProperties = {};
	if (url) {
		conditionalProperties.href = url;
		conditionalProperties.target = '_blank';
	}
	return (
		<div data-toggle="tooltip" title={tooltip ? tooltip : ''}>
			<ElementTag className="notification-box" {...conditionalProperties}>
				{icon}
				{children}
				{badge}
			</ElementTag>
		</div>
	);
};

/**
 * A component that will display in the upper-right hand corner of a NotificationBox.
 * 
 * @param count The contents of the badge
 * @param color The background color of the badge (Create new colors by adding a .notification-box-badge.{color} CSS rule)
 */
export const BadgeCount = ({ count, color }) => {
	if (!count && count !== 0) {
		return null;
	}

	const colorClass = color || '';
	return <span className={`notification-box-badge ${colorClass}`}>{count}</span>;
};

export default NotificationBox;